import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteSpotModalitiesService = async (
  modalityId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/spots/modalities/${modalityId}`);
};

export default deleteSpotModalitiesService;
